/** Tipos derivados da OpenAPI do backend PontoFlow. */

// ── Feriado ───────────────────────────────────────────────────────────────────

export interface Feriado {
  id: string
  data: string
  nome: string
  tipo: 'NACIONAL' | 'ESTADUAL' | 'MUNICIPAL' | 'FACULTATIVO' | 'PERSONALIZADO'
  uf: string | null
  municipio: string | null
  recorrente: boolean
  ativo: boolean
}

// ── Política de Trabalho ──────────────────────────────────────────────────────

export interface PoliticaTrabalho {
  id: string
  nome: string
  jornada_horas_dia: number
  jornada_horas_semana: number
  tolerancia_entrada_min: number
  tolerancia_saida_min: number
  intervalo_min_minutos: number
  intervalo_deducao_automatica: boolean
  intervalo_deducao_minutos: number
  extra_pct_dia_util: number
  extra_pct_feriado: number
  extra_pct_dsf: number
  extra_limite_diario_min: number
  noturno_habilitado: boolean
  noturno_percentual: number
  noturno_inicio: string
  noturno_fim: string
  noturno_hora_reduzida: boolean
  dsr_habilitado: boolean
  dsr_dia_semana: number
  dsr_proporcional_faltas: boolean
  itinere_habilitado: boolean
  itinere_minutos_ida: number
  itinere_minutos_volta: number
  itinere_base_legal: string | null
  banco_horas_habilitado: boolean
  banco_horas_tipo: string
  banco_horas_prazo_meses: number
  banco_horas_limite_positivo_h: number
  banco_horas_limite_negativo_h: number
  ativo: boolean
  created_at: string
}

// ── Escala de Trabalho ────────────────────────────────────────────────────────

export interface EscalaTrabalho {
  id: string
  nome: string
  tipo: 'FIXO' | 'FLEXIVEL' | '12X36' | '6X1' | 'TURNO'
  entrada: string | null
  saida: string | null
  intervalo_inicio: string | null
  intervalo_fim: string | null
  trabalha_seg: boolean
  trabalha_ter: boolean
  trabalha_qua: boolean
  trabalha_qui: boolean
  trabalha_sex: boolean
  trabalha_sab: boolean
  trabalha_dom: boolean
  carga_horaria_dia: number | null
  config_json: string | null
  ativo: boolean
  created_at: string
}

// ── Empresa / Filial ──────────────────────────────────────────────────────────

export interface Empresa {
  id: string
  nome: string
  cnpj: number | null
  ie: string | null
  endereco: string | null
  cidade: string | null
  uf: string | null
  ativo: boolean
  created_at: string
}

// ── REP (Relógio de Ponto) ────────────────────────────────────────────────────

export interface RepDevice {
  id: string
  vendor: string
  model: string
  descricao: string | null
  empresa_id: string | null
  numero_serie: string | null
  numero_equipamento: number | null
  local_equipamento: string | null
  host: string
  port: number
  afd_mode: 'p671' | 'legado'
  cert_fingerprint: string | null
  last_nsr: number
  ativo: boolean
  created_at: string
}

export interface RepTestResult {
  ok: boolean
  message: string
}

export interface RepSyncResponse {
  synced: number
  errors: string[]
}

// ── Funcionário ───────────────────────────────────────────────────────────────

export type TipoContrato = 'CLT' | 'PJ' | 'ESTAGIO' | 'APRENDIZ'

export interface Funcionario {
  id: string
  nome: string
  cpf: number
  pis: number | null
  empresa_id: string | null
  rg: string | null
  cracha: string | null
  registro_folha: string | null
  celular: string | null
  email: string | null
  matricula: string | null
  cargo: string | null
  departamento: string | null
  local_trabalho: string | null
  data_admissao: string
  data_demissao: string | null
  aviso_previo_data: string | null
  jornada_horas_dia: number
  tipo_contrato: TipoContrato
  politica_id: string | null
  escala_id: string | null
  ativo: boolean
}

export type TipoAtestado =
  | 'DOENCA' | 'ACIDENTE_TRABALHO' | 'ACIDENTE_PESSOAL'
  | 'MATERNIDADE' | 'PATERNIDADE' | 'ACOMPANHANTE' | 'OUTROS'

export interface FuncionarioDependente {
  id: string
  funcionario_id: string
  nome: string
  parentesco: string
  data_nascimento: string | null
  cpf: number | null
  ir_declarado: boolean
}

export interface FuncionarioAtestado {
  id: string
  funcionario_id: string
  data_inicio: string
  data_fim: string
  dias_afastamento: number
  tipo: TipoAtestado
  cid: string | null
  medico: string | null
  crm: string | null
  observacao: string | null
}

export type TipoExame = 'ADMISSIONAL' | 'PERIODICO' | 'DEMISSIONAL' | 'RETORNO' | 'MUDANCA_FUNCAO'
export type ResultadoExame = 'APTO' | 'APTO_RESTRICAO' | 'INAPTO'

export interface FuncionarioExame {
  id: string
  funcionario_id: string
  tipo: TipoExame
  data_exame: string
  data_vencimento: string | null
  resultado: ResultadoExame
  medico: string | null
  observacao: string | null
  vencido: boolean
}

export interface FuncionarioHistoricoCargo {
  id: string
  funcionario_id: string
  cargo: string
  departamento: string | null
  empresa_id: string | null
  data_inicio: string
  data_fim: string | null
  salario: number | null
  motivo_alteracao: string | null
}

// ── Espelho de Ponto ──────────────────────────────────────────────────────────

export type EspelhoStatusValue = 'ABERTO' | 'EM_TRATAMENTO' | 'FECHADO'

export interface EspelhoSummary {
  id: string
  funcionario_cpf_pis: number
  data: string
  status: EspelhoStatusValue
  horas_normais_s: number | null
  horas_extras_s: number | null
  horas_noturnas_s: number | null
  horas_falta_s: number | null
  clt_version: string
  fechado_em: string | null
}

export interface MarcacaoDetalhe {
  nsr: number
  timestamp: string
  tipo: 'ENTRADA' | 'SAIDA' | 'DESCONHECIDO'
  raw_line: string
}

export interface EspelhoDetail extends EspelhoSummary {
  marcacoes: MarcacaoDetalhe[]
}

// ── Tratamento ────────────────────────────────────────────────────────────────

export type TratamentoTipo = 'ABONO' | 'AJUSTE' | 'JUSTIFICATIVA'

export interface Tratamento {
  id: string
  espelho_id: string
  tipo: TratamentoTipo
  ator_id: string
  motivo: string
  antes_json: string
  depois_json: string
  criado_em: string
}

// ── Utilidades ────────────────────────────────────────────────────────────────

/** Converte segundos para string de horas: ex 29700 → "8h15" */
export function formatHoras(segundos: number | null | undefined): string {
  if (segundos == null) return '—'
  const h = Math.floor(segundos / 3600)
  const m = Math.floor((segundos % 3600) / 60)
  return m > 0 ? `${h}h${String(m).padStart(2, '0')}` : `${h}h`
}

/** Formata CPF: 12345678901 → "123.456.789-01" */
export function formatCpf(cpf: number): string {
  const s = String(cpf).padStart(11, '0')
  return `${s.slice(0, 3)}.${s.slice(3, 6)}.${s.slice(6, 9)}-${s.slice(9)}`
}

export type Role =
  | 'SUPER_ADMIN'
  | 'ADMIN_TENANT'
  | 'GESTOR_RH'
  | 'OPERADOR'
  | 'FUNCIONARIO'

export type Plan = 'GRATUITO' | 'BÁSICO' | 'PROFISSIONAL'

export type SubscriptionStatus =
  | 'TRIAL'
  | 'ATIVA'
  | 'INADIMPLENTE'
  | 'SUSPENSA'
  | 'CANCELADA'

// ── Auth ──────────────────────────────────────────────────────────────────────

export interface LoginRequest {
  email: string
  password: string
  turnstile_token: string | null
}

export interface LoginResponse {
  access_token: string
  token_type: 'bearer'
}

export interface TokenClaims {
  sub: string       // user_id
  tenant_id: string
  role: Role
  plan: Plan
  iss: string
  aud: string
  exp: number
  iat: number
}

// ── Users ─────────────────────────────────────────────────────────────────────

export interface UserMe {
  id: string
  email: string
  role: Role
}

export interface AppUser {
  id: string
  tenant_id: string
  email: string
  role: Role
  created_at: string
}

// ── Billing ───────────────────────────────────────────────────────────────────

export interface SubscriptionResponse {
  tenant_id: string
  plan: Plan
  status: SubscriptionStatus
  periodo_fim: string | null
}

// ── Super-Admin ───────────────────────────────────────────────────────────────

export interface TenantSummary {
  id: string
  name: string
  plan: Plan
  created_at: string
}

export interface TenantDetail extends TenantSummary {
  subscription_status: SubscriptionStatus | null
}

export interface PlanMetrics {
  plan: Plan
  count: number
}

export interface ProductMetrics {
  total_tenants: number
  tenants_por_plano: PlanMetrics[]
  assinaturas_ativas: number
}

// ── LGPD ─────────────────────────────────────────────────────────────────────

export type LgpdRequestType =
  | 'ACESSO'
  | 'CORRECAO'
  | 'ELIMINACAO'
  | 'PORTABILIDADE'
  | 'REVOGACAO_CONSENTIMENTO'

export type LgpdRequestStatus = 'PENDENTE' | 'EM_ANALISE' | 'CONCLUIDO' | 'INDEFERIDO'

export interface LgpdRequest {
  id: string
  tipo: LgpdRequestType
  status: LgpdRequestStatus
  justificativa: string | null
  resposta: string | null
  criado_em: string
  concluido_em: string | null
}

// ── API Error ─────────────────────────────────────────────────────────────────

export interface ApiError {
  detail: string
  status?: number
}
